<template>
  <div id="app">
    <el-scrollbar style="height: 100%;">
      <div class="booooooz">


        <router-view />

      </div>
      <div class="gb_foot_zfw">

      </div>
      <div class="gb_foot">

        <div class="f2">
          <div class="l1">
            <div class="tit">
              {{ $lang(52653)}}
            </div>
            <div class="row">
              <div v-for="(itm, i) in list" :key="i" class="itmz" @click="jump2('/page?id=' + itm.id)">
                {{ itm.strs.title }}
              </div>
            </div>
          </div>
          <div class="l11">
            <div class="tit">{{ $lang(55240)}}</div>
            <div>
              <div class="row">
                <div class="itmz" @click="jump('/points')">
                  {{ $lang(55239)}}
                </div>
                <div v-for="(itm, i) in cate" :key="i" class="itmz" @click="note_jump(itm.id)">
                  {{ itm[cur_lang()] == '公告' ? $lt('网站公告') : itm[cur_lang()] }}
                </div>
                <div class="itmz" @click="jump('/ser')">
                 {{ $lt('客服中心') }}
                </div>
              </div>
            </div>
          </div>

          <div class="l11">
            <div class="tit">{{ $lt('在线咨询') }}</div>
           <div class="cuss"> <img class="imzzz" src="~@/../static/kf.jpg" alt=""></div>
          </div>
          <div class="l11">
            <div class="tit">{{ $lang(70390)}}</div>
            <div class="cuss"> <img class="imzzz" src="~@/../static/wxpla.jpg" alt=""></div>
          </div>



        </div>

        <div class="f0">
          <a href="http://beian.miit.gov.cn/" style="color:#6d6d6d" target="_blank">{{ $lt('copyright') }}</a>

        </div>




      </div>
    </el-scrollbar>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        conf: {},
        list: [],
        cate: [],
      }
    },
    methods: {
      note_jump(id) {
        if (id == '84') {
          this.jump('/scenic')
        } else {
          this.jump('/article?c=' + id)
        }
      },
      f5() {
        this.get("/index/conf", {}, 'GET', true).then((e) => {


          this.conf = e.conf
          this.list = e.list
          this.cate = e.cate

        });
      },
    },
    mounted() {
      // 已停用：窄屏自动跳转手机版（同时避免预渲染 headless 视口触发跳转）
      // if (document.body.clientWidth <= 900) {
      //   window.location.href = 'http://wx.japanbus.cn/'
      // }
      this.f5()
      // alert(document.body.clientWidth)
    },

  }
</script>
<style lang="scss">
@font-face {
  font-family: 'v3ui';
  src: url("/static/YOUSHEBIAOTIHEI-2.TTF");
}
</style>
<style scoped>

  .f2 {
    display: flex; 
    /* padding: 30px 10%; */
    color: #333333;
    font-weight: 500;
    max-width: 1200px;
    margin: 0 auto;
  }

  .f2 .tit {
    line-height: 40px;
    height: 40px;
    font-size: 20px;
    font-weight: bold;
    color: #2c3e50;
    margin-bottom: 10px;
  }

  .cuss {
    white-space: nowrap;
    padding: 5px;
  }

  /* .cuss td, .cuss table {
  border: none !important;
} */
  .f2 .l1 {
    flex: 0 0 24%; 
  }

  .f2 .l11 {
    flex: 0 0 25%; 
  }

  .f2 .l2 {
    flex: 0 0 48%;

  }

  .f2 .row {
    display: flex;
    flex-wrap: wrap;
  }

  .f2 .row .itmz {
    padding: 8px 5px;
    flex: 0 0 45%;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s ease;
    border-radius: 4px;
  }
  
  .f2 .row .itmz:hover {
    background: rgba(80, 162, 248, 0.1);
    color: #50A2F8;
  }

  .imzzz {
    width: 160px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    transition: transform 0.3s ease;
  }
  
  .imzzz:hover {
    transform: scale(1.05);
  }

  .f0 {
     
    color: #6d6d6d;
    /* border-top: 1px solid #eaeaea; */
    padding: 0px 0;
    font-size: 12px;
    margin-top: 20px;
  }
  
  .f0 a {
    transition: color 0.3s ease;
  }
  
  .f0 a:hover {
    color: #50A2F8;
  }
</style>
<style>
  body {
    margin: 0 auto;
    overflow-x: hidden;
  }

  .city_tag {
    background: #eb5100;
    color: #fff;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    padding: 2px 4px;
    margin-right: 4px;
    border-radius: 5px;
    min-width: 40px;
    text-align: center;

  }

  .incoimg {
    width: 18px;
    height: 18px;
    display: block;
    margin-right: 5px;
  }

  .trtagzz {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .booooooz {
    /* min-height: 98vh; */
  }

  .gb_foot {
    padding: 20px 0;
    text-align: center;
    justify-content: center;
    background: #eee;
    box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
    margin-top: 30px;
  }

  .diffzaa {
    margin: 0 20px;
  }

  .btf_soll {
    overflow-x: auto;
  }

  .btf_soll td {

    padding: 5px 10px;
    text-align: center;
    height: 10px;


  }

  .btf_soll::-webkit-scrollbar {
    width: 7px;
    height: 7px;
    background-color: #f5f5f5;
  }

  .btf_soll::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    background-color: #c8c8c8;
  }

  .btf_soll::-webkit-scrollbar-corner {

    background-color: black;

  }

  .btf_soll::-webkit-scrollbar-button {

    background-color: rgb(189, 45, 45);
    color: #f5f5f5;
    display: none;
  }

  .btf_soll::-webkit-scrollbar-track {

    box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5
  }

  .time_division_type {
    background-color: #0464dd !important;
    color: #fff !important;
  }

  .v3_body {
    background-image: url("/static/image/v3bg.png");
    background-repeat: no-repeat;
    background-size: 100% auto;
    padding-bottom: 20px;
    /* background-color: #ebf6ff; */
  }

  .gb-tabs {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    margin: 20px 0;
    overflow: hidden;
    border: 1px solid #f0f0f0;
  }

  .gb-tabs-header {
    display: flex;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-bottom: 1px solid #e9ecef;
    padding: 0 20px;
    position: relative;
  }

  .gb-tab {
    padding: 16px 24px;
    cursor: pointer;
    font-weight: 500;
    font-size: 16px;
    color: #6c757d;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    margin-right: 8px;
    border-bottom: 3px solid transparent;
    user-select: none;
    white-space: nowrap;
  }

  .gb-tab:hover {
    color: #50A2F8;
    background: rgba(80, 162, 248, 0.05);
    transform: translateY(-1px);
  }

  .agtabat {
    color: #50A2F8;
    background: rgba(80, 162, 248, 0.08);
    border-bottom: 3px solid #50A2F8;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(80, 162, 248, 0.15);
  }

  .agtabat::after {
    content: '';
    position: absolute;
    bottom: -3px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 3px;
    background: linear-gradient(90deg, #50A2F8, #4095ea);
    border-radius: 3px 3px 0 0;
  }

  .gb-tabs-body {
    background: #fff;
    padding: 24px;
    border-radius: 0 0 12px 12px;
  }

  @media (max-width: 768px) {
    .gb-tabs-header {
      padding: 0 10px;
    }
    
    .gb-tab {
      padding: 12px 16px;
      font-size: 14px;
    }
  }

  /* 添加加载状态的样式 */
  .gb-tabs[v-loading] {
    position: relative;
  }

  .gb-tabs[v-loading]::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    z-index: 2000;
    border-radius: 12px;
  }

.bdall {
  /* border: 1px solid #c7c7c7; */
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/App.vue